import * as React from 'react';
export const IcSpeakerMegaphone = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.1 4.21L3.91 9.9c-.55.21-.91.73-.91 1.32v2.49c0 .62.4 1.16.99 1.34l.57.18c-.25.86-.15 1.77.29 2.56a3.31 3.31 0 002.01 1.6c.31.09.62.13.93.13.56 0 1.12-.14 1.62-.42.74-.41 1.28-1.08 1.55-1.88l8.21 2.57c.91.28 1.83-.39 1.83-1.34V5.53c0-.98-.98-1.66-1.9-1.32zM8.33 17.14c-.26.15-.56.18-.85.1a1.11 1.11 0 01-.67-.53c-.14-.25-.17-.53-.1-.8l2.1.66c-.09.24-.26.45-.49.58l.01-.01z'
      fill='currentColor'
    />
  </svg>
);
